<script setup lang="ts">
import { vDialogContainer, type DialogContainerOptions } from '@fusapp-work/ui-kit/cosmos'
import { onMounted, ref } from 'vue'
import { useI18n, useRouter } from '@fusapp-work/shell'
import { useConsoleSearch } from './useConsoleSearch'
import ShellIcon from './ShellIcon.vue'
defineProps<{ returnFocus?: DialogContainerOptions['returnFocus'] }>()
const emit = defineEmits<{ close: [] }>()
const { t } = useI18n(); const router = useRouter()
const { search, groups, loading, error, admin, orgId } = useConsoleSearch()
const dialog = ref<HTMLDialogElement>()
onMounted(() => dialog.value?.showModal())
function move(event: KeyboardEvent) {
  const controls = [...dialog.value!.querySelectorAll<HTMLElement>('input, .console-search-results button')]
  const index = controls.indexOf(document.activeElement as HTMLElement)
  if (['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); controls[(index + (event.key === 'ArrowDown' ? 1 : controls.length - 1)) % controls.length]?.focus() }
}
</script>
<template>
  <dialog
    ref="dialog"
    v-dialog-container="{ close: () => dialog?.close(), body: '.console-search-results', returnFocus }"
    class="console-dialog console-palette"
    :aria-label="t('consoleShell.search')"
    @close="emit('close')"
    @click="$event.target === dialog && dialog?.close()"
    @keydown="move"
  >
    <header class="console-dialog-header">
      <ShellIcon name="search" /><input
        v-model="search"
        autofocus
        :aria-label="t('consoleShell.search')"
        :placeholder="t('consoleShell.searchPlaceholder')"
      ><button
        class="console-icon-button"
        :aria-label="t('consoleShell.close')"
        @click="dialog?.close()"
      >
        <kbd>esc</kbd>
      </button>
    </header>
    <div
      class="console-search-results"
      :aria-busy="loading"
    >
      <template
        v-for="group in groups"
        :key="group.key"
      >
        <div
          class="console-palette-group"
          :data-palette-group="group.key"
        >
          {{ t(`consoleShell.${group.key}`) }}
        </div>
        <button
          v-for="item in group.items"
          :key="item.id"
          :data-command="item.id"
          @click="router.push(item.to); dialog?.close()"
        >
          <ShellIcon :name="item.icon" /><span>{{ item.label }}</span><small>{{ item.hint }}</small>
        </button>
      </template>
      <p
        v-if="loading"
        role="status"
      >
        {{ t('organization.common.loading') }}
      </p>
      <p
        v-else-if="error"
        role="status"
      >
        {{ t('consoleShell.recordsUnavailable') }}
      </p>
      <p
        v-else-if="!groups.length"
        role="status"
      >
        {{ t('consoleShell.noResults') }}
      </p>
      <small
        v-if="!admin"
        class="console-search-notice"
      >{{ t('consoleShell.recordsPermission') }}</small><small
        v-else-if="!orgId"
        class="console-search-notice"
      >{{ t('consoleShell.selectOrganization') }}</small>
    </div>
  </dialog>
</template>
